import store from "../../store";
import { failureToast } from "../../store/dbFilter/actions";

export const handleAPISuccess = (response) => {
  if (response?.data === null) {
    console.log("Something went wrong");
    return;
  }

  if (
    response?.data?.message ||
    response?.data?.is_error ||
    response?.data?.data
  ) {
    const { is_error, message, data } = response?.data;
    if (is_error) {
      console.log("message: ", message || "Unexpected error.");
      console.log("Type of error: ", response?.problem);
      // return;
      const errorObject = {
        isErr: true,
        msg: message || "Unexpected error.",
        problem: response?.problem,
      };
      throw errorObject
    }
    // console.log(`${message}`, data);
    // console.log
    // (("handleAPISuccess data:", data));
    return { message, data };
  } else {
    return { message: "success", data: response?.data };
  }
};

export const handleAPIError = (err) => {
  console.log(err);
  
  // Custom object structure that you were using before
  const errorObject = {
    isErr: true,
    msg: "",
    problem: "",
  };
  // console.log("Error logs handleAPIError: ", err);

  if (err.name === "ValidationError") {
    // Handle validation errors
    errorObject.msg = "Validation Error: " + err.errors.join(", ");
    errorObject.problem = "Validation";
    // console.log("Validation Error: ", err.errors);
  } else if (err.response) {
    // Handle API errors
    errorObject.msg =
      err.response?.data?.message || err.message || "API error occurred";
    errorObject.problem = "API";

    // console.log("API Error: ", errorObject.msg);
  } else {
    // Handle network or unexpected errors
    errorObject.msg = err.message || "Network error occurred";
    errorObject.problem = "Network";
    // console.log("Network Error: ", err.message);
  }
  store.dispatch(failureToast({ title:  errorObject.problem , message: errorObject.msg }))
  throw errorObject;
};

// to remove all the fields from the objects that does not have the values
export const removeEmptyFields = (obj) => {
  const cleanedObj = Object.fromEntries(
    Object.entries(obj).filter(([key, value]) => value !== '' && value !== null && value !== undefined)
  );
  return cleanedObj;
};